/*********
 * 2018/07/04
 * agosto
 * 单元测试文件: _test_/util/approvelHelper.test.js 修改逻辑时请同步修改单元测试
 */
import { isNotEmpty } from './check';
import Staff from '../Field_Components/Staff/Staff';
import NextApprover from '../Field_Components/NextApprover/NextApprover';
import JumpToSpecify from '../Field_Components/JumpToSpecify/JumpToSpecify';
import TextAreaComponent from '../Field_Components/TextAreaCompoent/TextAreaCompoent';
import AddSign from '../Field_Components/AddSign/AddSign';
import transLoader from '@beisen/i18n-translation-loader';
/*
下一节点执行人字段元数据
-----注意-----
下一节点执行人：非必填
单人/多人由接口提供
**/
const defaultTranslation = {
    nextApproverLabel: '下一节点执行人',
    required: '必填',
    toNode: '至节点',
    transferTo: '转交人',
    transferToDesc: '转交任务的接受者',
    approvelComment: '审批意见',
    retweetedComment: '转交原因',
    addsignComment: '加签原因',
    retrieveComment: '撤回原因',
    signType: '加签类型',
    signApprovers: '加签人员',
    fieldMaxLengthError: '最多输入$length个字'
};
const translation = Object.assign(
    {},
    defaultTranslation,
    transLoader({
        nextApproverLabel: 'approval.nextApproverLabel',
        required: 'common.required',
        toNode: 'approval.toNode',
        transferTo: 'approval.transferTo',
        transferToDesc: 'approval.transferToDesc',
        approvelComment: 'approval.approvelComment',
        retweetedComment: 'approval.retweetedComment',
        addsignComment: 'approval.addsignComment',
        retrieveComment: 'approval.retrieveComment',
        signType: 'approval.signType',
        signApprovers: 'approval.signApprovers',
        fieldMaxLengthError: 'approval.fieldMaxLengthError'
    })
);
export const hasNextApprover = params => {
    return params && params.useTemplate == 'appointapprover';
};
export function nextApproverMetaData(popOptions) {
    const { nextApproverLabel } = translation;
    const hasParams = isNotEmpty(popOptions, ['params']);
    const workflowTaskId =
        (hasParams && popOptions.params.workflowTaskId) ||
        '00000000-0000-0000-0000-000000000000';
    const actionValue = hasParams && popOptions.params.actionValue;
    const type = hasParams && popOptions.params.appointApproverType;
    const isSystemAction = hasParams && popOptions.params.isSystemAction;
    return {
        workflowTaskId,
        actionValue,
        type,
        isSystemAction,
        cmp_id: 'ANT_6a4b758b-dbfb-4a1e-b968-9a4a96dfe7f3',
        cmp_name: 'wf_NextApprover',
        cmp_type: 'BC_NextApprover',
        required: false,
        cmp_label: nextApproverLabel,
        label: nextApproverLabel,
        cmp_data: {
            title: nextApproverLabel,
            singleSelect: false,
            field_name: 'wf_NextApprover',
            isLink: false,
            required: false,
            cmp_state: 'create',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            desc: '',
            icon_name: ''
        }
    };
}

/*
跳转字段元数据
跳转为必填，单选
数据源由接口提供
**/
export const hasJumpTo = params => {
    //单人节点时不显示此字段
    const isSingleActivityJump =
        isNotEmpty(params, ['isSingleActivityJump']) &&
        params.isSingleActivityJump.toLowerCase() == 'true';
    return (
        params && params.useTemplate == 'jumptospecify' && !isSingleActivityJump
    );
};
export function JumpToMetaData(popOptions) {
    const { toNode, required } = translation;
    const hasParams = isNotEmpty(popOptions, ['params']);
    const title = `${(popOptions && popOptions.buttonTitle) ||
        (hasParams && popOptions.params.title)}${toNode}`;
    const taskObjectId = hasParams && popOptions.params.taskObjectId;
    return {
        taskObjectId,
        cmp_id: 'AJP_2a3b758b-dbfb-4a1e-b968-9a4a96dfe7f3',
        cmp_name: 'wf_JumpTo',
        cmp_type: 'BC_JumpTo',
        required: true,
        cmp_label: title,
        label: title,
        cmp_data: {
            title: title,
            field_name: 'wf_JumpTo',
            isLink: false,
            required: true,
            cmp_state: 'create',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            desc: '',
            icon_name: '',
            datasource: []
        },
        validators: { presence: { message: `^${required}` } }
    };
}

/*
转交字段元数据
转交为必填，单人
**/
export const hasTransfer = params => {
    return params && params.useTemplate == 'retweeted';
};
export function transferToMetaData() {
    const { transferTo, required } = translation;
    return {
        cmp_id: 'AT_2a4b758b-dbfb-4a1e-b968-9a4a96dfe7f3',
        cmp_name: 'wf_TransferTo',
        cmp_type: 'BC_UserSelect',
        required: true,
        cmp_label: transferTo,
        label: transferTo,
        cmp_data: {
            title: transferTo,
            singleSelect: true,
            field_name: 'wf_TransferTo',
            isLink: false,
            required: true,
            cmp_state: 'create',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            desc: '',
            icon_name: ''
        },
        validators: { presence: { message: `^${required}` } }
    };
}

/*
意见参数控制是否必填 默认字段名称为审批意见
--------注意特殊字段名称-------
 转交时 字段名称为转交原因 useTemplate == 'retweeted'
 加签原因：字段名称由接口提供
**/
export const hasComment = params => {
    return (
        params && (params.AC_commentType == '1' || params.AC_commentType == '2')
    );
};
export function commentMetaData(popOptions) {
    let {
        approvelComment,
        required,
        retweetedComment,
        addsignComment,
        retrieveComment,
        fieldMaxLengthError
    } = translation;
    const hasParams = isNotEmpty(popOptions, ['params']);
    const params = (hasParams && popOptions.params) || '';
    const template = hasParams && popOptions.params.useTemplate;
    let cmpLabel = approvelComment;
    let fieldRequired = hasParams && popOptions.params.AC_commentType == '2';
    /**转交原因 */
    if (template === 'retweeted') {
        cmpLabel = retweetedComment;
    }
    /**加签原因 */
    if (template === 'addsign') {
        cmpLabel = addsignComment;
    }

    /**撤回原因 */
    if (params.actionValue === 'Retrieve') {
        cmpLabel = retrieveComment;
    }
    let maxLength = 2000;
    //审批意见添加2000字超长校验
    fieldMaxLengthError = fieldMaxLengthError.replace('$length', maxLength);
    let validators = {
        length: {
            maximum: maxLength,
            minimum: 0,
            tooLong: `^${fieldMaxLengthError}`,
            tooShort: '^'
        }
    };
    //如果必填
    if (fieldRequired) {
        validators.presence = { message: `^${required}` };
    }
    return {
        cmp_id: 'WF_db36f4e6-e327-431a-bb2a-e19383068796',
        cmp_name: 'wf_Comment',
        cmp_type: 'BC_TextArea',
        cmp_label: cmpLabel,
        label: cmpLabel,
        required: fieldRequired,
        cmp_data: {
            title: cmpLabel,
            label: cmpLabel,
            field_name: 'wf_Comment',
            required: fieldRequired,
            cmp_state: 'edit',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            icon_name: ''
        },
        validators
    };
}

/**
 * 加签
 */
export const hasSign = params => {
    return params && params.useTemplate == 'addsign';
};
export function signTypeMetaData(popOptions) {
    const { signType, required } = translation;
    return {
        cmp_id: 'ST_6a4b758b-dbfb-4a1e-b968-9a4a96dfe7f3',
        cmp_name: 'wf_SignType',
        cmp_type: 'BC_SignType',
        required: true,
        cmp_label: '',
        label: signType,
        cmp_data: {
            title: signType,
            singleSelect: false,
            field_name: 'wf_SignType',
            isLink: false,
            required: true,
            cmp_state: 'create',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            desc: '',
            icon_name: ''
        },
        validators: { presence: { message: `^${required}` } }
    };
}
export function signApproversMetaData(popOptions) {
    const { signApprovers, required } = translation;
    return {
        cmp_id: 'SA_6a4b758b-dbfb-4a1e-b968-9a4a96dfe7f3',
        cmp_name: 'wf_SignApprovers',
        cmp_type: 'BC_SignApprovers',
        required: true,
        cmp_label: '',
        label: signApprovers,
        cmp_data: {
            title: signApprovers,
            singleSelect: false,
            field_name: 'wf_SignApprovers',
            isLink: false,
            required: true,
            cmp_state: 'create',
            cmp_status: 'editable',
            editdisplaystate: 'editable',
            createdisplaystate: 'editable',
            showdisplaystate: 'readonly',
            desc: '',
            icon_name: ''
        },
        validators: { presence: { message: `^${required}` } }
    };
}

export function signMetaData(popOptions) {
    const hasParams = isNotEmpty(popOptions, ['params']);
    const workflowTaskId = hasParams && popOptions.params.workflowTaskId;
    return {
        workflowTaskId,
        required: true,
        signType: signTypeMetaData(popOptions),
        signApprovers: signApproversMetaData(popOptions)
    };
}
export const approvelCmps = [
    'wf_NextApprover',
    'wf_JumpTo',
    'wf_TransferTo',
    'wf_Comment',
    'wf_AddSign'
];
/**
 * 审批字段数组
 * name： 字段名称
 * isExist: 判断字段是否存在的function
 * getMetaData: 获取字段元数据的function
 * taskKey: task提交时postData的key值
 */
export const approvelFields = [
    {
        name: 'wf_NextApprover',
        cmp: NextApprover,
        isExist: hasNextApprover,
        getMetaData: nextApproverMetaData,
        taskKey: 'appointApprovers',
        needFormLoad: true
    },
    {
        name: 'wf_JumpTo',
        cmp: JumpToSpecify,
        isExist: hasJumpTo,
        getMetaData: JumpToMetaData,
        taskKey: 'specifyActityId',
        needFormLoad: true
    },
    {
        name: 'wf_TransferTo',
        cmp: Staff,
        isExist: hasTransfer,
        getMetaData: transferToMetaData,
        taskKey: 'transferTo',
        needFormLoad: false
    },
    {
        name: 'wf_AddSign',
        cmp: AddSign,
        isExist: hasSign,
        getMetaData: signMetaData,
        taskKey: [
            {
                name: 'wf_SignType',
                label: translation.signType,
                taskKey: 'addSignType'
            },
            {
                name: 'wf_SignApprovers',
                label: translation.signApprovers,
                taskKey: 'addSignApprovers'
            }
        ],
        needFormLoad: true
    },
    {
        name: 'wf_Comment',
        cmp: TextAreaComponent,
        isExist: hasComment,
        getMetaData: commentMetaData,
        taskKey: 'comment',
        needFormLoad: false
    }
];

/**
 * 存在的审批字段数组
 */
export function getExistFields(popOptions) {
    const params = popOptions && popOptions.params;
    return approvelFields.filter(field => {
        return field.isExist(params);
    });
}

export const SIGNBEFORE = '1'; // 前加签
export const SIGNAFTER = '3'; // 后加签
export const SIGNAND = '2'; // 并加签



// WEBPACK FOOTER //
// ./src/components/util/approvelHelper.js